/* jshint -W072 */ // TO DO: fix maxparams violation.  Customer service doesn't do much and could be rolled into customer object from auth.
/* jshint -W071 */ // TO DO: fix maxstatements violation. Likely same mitigation as above
angular.module('rightPaneModule')
  .controller('ClassroomOverviewController', [
        '$modal',
        '$q',
        '$scope',
        '$state',
        'authentication',
        'configuration',
        'customer',
        'timeframe',
        'classroomApi',
        'studentApi',
        '$filter',
        'tableSort',
        'tableColumns',
        'reportErrors',
        'dblAlertApi',
        'dblPrintAllStudentsModalService',
        'edxReportItemService',
        '$rootScope',
        'dblAnalyticsProvider',
    function(
        $modal,
        $q,
        $scope,
        $state,
        authentication,
        configuration,
        customer,
        timeframe,
        classroomApi,
        $studentApi,
        $filter,
        $tableSort,
        $tableColumns,
        $reportErrors,
        dblAlertApi,
        dblPrintAllStudentsModalService,
        edxReportItemService,
        $rootScope,
        analyticsService
    ) {

    $scope.useBts2020Nav = authentication.useBts2020Nav();

    function updateMode() {
        $scope.viewMode = authentication.growthAsFraction()  ? 'fractionMode' : 'percentMode';

        var columns = {
            'fractionMode': 'studentCompletionFractionMode',
            'percentMode' : 'studentCompletion'
        };

        $scope.columns = $tableColumns.getColumns(columns[$scope.viewMode]);
    }

    $scope.tableSortService = $tableSort;
    var thisYear = new Date().getFullYear();
    $scope.years = {list: [thisYear - 1, thisYear - 2], selected: {}}; // We only keep 2 years of data
    $scope.loadingPage = false;

    var translate = $filter('translate');
    $scope.timeframes = {
        list: [
            {id: '1d', name: translate('shared.timeframes.today'), by: 'day', active: false},
            {id: '0w', name: translate('shared.timeframes.thisWeek'), by: 'day', active: true},
            {id: '7d', name: translate('shared.timeframes.last7Days'), by: 'day', active: false},
            {id: '30d', name: translate('shared.timeframes.last30Days'), by: 'week', active: false}
        ],
        selected: {}
    };
    $scope.ADDITIONAL_GRADES = 1;

    function calculateGrade(gradeLevel, students) {
      var grade = gradeLevel;

      grade = parseInt(grade);

      // If classroom is multigrade find the most common grade of the students
      if (grade === 1000 || grade === 1001) {
        grade = getMostCommonGradeLevel(students);
      }
      // If the grade is high show a range of 7th, 8th, 9th (Algebra)
      if (grade > 8) {
        grade = 8;
      }
      // If the grade is low show a range of 0 (Kindergarten), 1st, 2nd
      else if (grade < 1) {
        grade = 1;
      }

      return grade;
    }

    function getAllGrades() {
      return _.range(0, 9);
    }

    function getMostCommonGradeLevel(students) {
        var classroomGrades = _.map(students, function(student) {
            return student.curricular_grade_level;
        });
        return parseInt(
          _.chain(classroomGrades)// Example: [0, 0, 1, 2]
            .countBy() // {0: 2, 1: 1, 2: 1}
            .pairs() // [["0", 2], ["1", 1], ["2", 1]]
            .max(_.last) // ["0", 2] (the pair with the largest last value)
            .head() // "0"
            .value());
    }

    function filterRows() {
        if (!$scope.columns || !$scope.listTableData || !$scope.listTableData.students_overview) {
            $scope.localRows = null;
            return;
        }
        $scope.localRows = angular.copy($scope.listTableData.students_overview);
        var astLevels = $scope.listTableData.ast_levels;
        var codeToOrdinal = {};
        _.map(astLevels, function(level) {
            codeToOrdinal[level.code] = level.ordinal;
        });

        $scope.localRows = _.map($scope.localRows, function(row) {
            _.forEach($scope.columns, function(column) {
                if (column.filter) {
                    // keep the raw data for rows with different data formats
                    if (column.id === 'total_session_time' || column.id === 'usage_extended_hours') {
                      row[column.id + '_sort_raw'] = row[column.id];
                    }
                    row[column.id] = $filter(column.filter)(row[column.id]);
                }
            });
            var sortedCompletion = $filter('orderBy')(row.levels_completion, function(l) {
                return codeToOrdinal[l.code];
            });
            row.levels_completion = sortedCompletion;
            return row;
        });
    }

    function updateBarCharts() {
        var tableData = $scope.listTableData;
        if (!tableData || !tableData.students_overview || tableData.students_overview.length === 0) {
            $scope.localRows = null;
            return;
        }

        $scope.allGrades = getAllGrades();
        $scope.selectedGrade = calculateGrade(tableData.grade_level, tableData.students_overview);
        $scope.datePrevious = timeframe.isCustomRange() ? null : timeframe.getPrettyFromDate('LL');
    }

    function handleStudentsReportingError(error) {
        $scope.studentsReportingError = $reportErrors.getErrorMessage(error);
        $scope.loadingPage = false;
    }

    function updateStudents() {
        $scope.disableLegacyAlertColumn = authCustomer.hasTag('INSIGHT_EFP') && configuration.isFeatureEnabled('alerts_efp_enabled');
        updateMode();

        $scope.loadingPage = true;
        // prevents no students message to show at start
        $scope.studentsUpdated = false;

        initializeSort();

        $scope.studentReportingExportUrl = $studentApi.getStudentsReportingForClassroomExportUrl();

        $scope.studentsReportingError = null;
        $scope.classroomData = undefined;
        var studentListPromise = $studentApi.getStudentsReportingForClassroom().then(function(data) {
            $scope.listTableData = angular.copy(data);
            $scope.studentProficiencies = [];
            $scope.showTable = false;

            var lessonsCompletedCount = 0;
            var standardsAchieved = 0;
            var percentGrowth = 0;
            var studentsOverview = data.students_overview;

            _.each(studentsOverview, function(student) {

                // studentProficiency is used with the flattened tetris grid of the new classroom overview
                var studentProficiency = {
                    id: student.id,
                    first_name: student.first_name,
                    last_name: student.last_name,
                    total_session_time: student.total_session_time,
                    lesson_count: student.count_lessons_completed,
                    // -- Warning when time is less than 15 minutes. I don't think this is right since this is total time
                    // not average time, but we'll go with it for now
                    // -- Update: Low usage badge is being disabled, it might come back in some form so keep the code
                    // is_low_usage: student.total_session_time < 15 * 60 * 1000,
                    grades: _.map(student.levels_completion, function(level){
                        return {
                            grade: level.grade,
                            level_id: level.code,
                            percent_complete: level.percent_complete,
                            standards_completed: level.standards_completed,
                            standards_count: level.standards_count,
                            lesson_count: level.count_lessons_completed
                        };
                    })
                };

                // Map grades for easy lookup in the flattened tetris grid component
                var gradeMap = {};
                _.each(studentProficiency.grades, function(grade) {
                    gradeMap[grade.grade] = grade;

                    // Augment data to help sorting by proficiency
                    studentProficiency['sort_grade' + grade.grade] = grade.standards_completed;
                });
                studentProficiency.grades = gradeMap;

                $scope.studentProficiencies.push(studentProficiency);

                if (student.count_lessons_completed) {
                    lessonsCompletedCount += student.count_lessons_completed;
                }

                if (student.standards_growth) {
                    standardsAchieved += student.standards_growth;
                }

                if (student.percent_growth) {
                    percentGrowth += _.round(student.percent_growth);
                }
            });

            $scope.showTable = $scope.studentProficiencies.length > 0;

            var classroomData= {};
            classroomData.countLessonsCompleted = lessonsCompletedCount;
            classroomData.standardsAchieved = studentsOverview.length ? _.round(standardsAchieved / studentsOverview.length, 1) : 0;
            classroomData.percentGrowth = studentsOverview.length ? percentGrowth / studentsOverview.length : 0;

            $scope.classroomData = classroomData;

            updateBarCharts();
            filterRows();
            updateSort();
            $scope.loadingPage = false;
            $scope.studentsUpdated = true;

            return $scope.listTableData;
        }, handleStudentsReportingError);

        var timeframeWithin30 = timeframe.getTimeframeWithinDays(30);
        if (timeframeWithin30 && timeframe.includesThePresent()) {
            var astName = customer.getAcademicStandard().academic_standard_name;
            var districtId = $state.params.districtId;
            var classroomId = $state.params.classroomId;
            var days = timeframeWithin30.days;
            var fd = timeframeWithin30.fd;
            var td = timeframeWithin30.td;

            var promises = {
                classroomAlerts: dblAlertApi.getClassroomAlertsWithText(districtId, classroomId, astName, days, fd, td),
                studentList: studentListPromise
            };

            $q.all(promises).then(function (data) {
                var alertsByUserId = _.indexBy(data.classroomAlerts, 'id');

                _.each($scope.localRows, function (student) {
                    var studentAlerts = alertsByUserId[student.id];
                    if (studentAlerts) {
                        student.alerts = studentAlerts.academic_alerts;
                        student.alertHtml = buildAlertHtml(student.alerts, student.first_name);
                    }
                });
            });
        }
    }

    function buildAlertHtml(alerts, studentName) {
        if (!alerts) {
            return '';
        }

        var alertTexts = _.chain(alerts)
                .pluck('text')
                .uniq()
                .value();

        var html = alertTexts.join('<br>');
        html += '<br><br>View ' + studentName + '\'s Activity tab to see recently completed lessons.';

        return html;
    }

    function updateSort() {
        $scope.loadingPage = false;
        sortTable();
    }

    function sortTable() {
        if (typeof $scope.localRows === "undefined" || $scope.localRows === null || $scope.localRows.length === 0) {
            return;
        }
        // Default to sort by name
        // (You can't count on the browser to keep keys in order)
        var columnName = $state.params.sort || $scope.columns[$tableSort.sortIndex].id;
        var columnsPassedAsStrings = ['average_weekly_session_time', 'percent_usage_extended_hours',
            'count_lessons_completed', 'percent_growth', 'total_session_time', 'standards_growth',
            'standards_partial_growth','usage_extended_hours'];
        var sorted;
        // Lots of properties in the table's rows come as strings from g2
        // If a column contains strings that should be sorted numerically then the strings must be parsed
        if (_.contains(columnsPassedAsStrings, columnName)) {
            sorted = $filter('orderBy')($scope.localRows, function(row) {
                // check if raw data is available to sort based on it
                if (row[columnName + '_sort_raw']) {
                  return parseFloat(row[columnName + '_sort_raw']);
                }
                return parseFloat(row[columnName]);
            }, $state.params.order === 'desc');
        }
        // If the column clicked is a grade copmletion column:
        else if ((_.find($scope.localRows[0].levels_completion, function(level) {
              return columnName === level.name;
          })) !== undefined) {
            var gradeIndex = _.findIndex($scope.localRows[0].levels_completion, function(level) {
                return columnName === level.name;
            });
            sorted = $filter('orderBy')($scope.localRows, function(row) {
                return row.levels_completion[gradeIndex].percent_complete;
            }, $state.params.order === 'desc');
        }
        // Otherwise, sort the column alphabetically by the string or number
        // If a particular property comes from g2 as a number it doesn't need parsing
        else {
            sorted = $filter('orderBy')($scope.localRows, columnName, $state.params.order === 'desc');
        }
        $scope.localRows = sorted;
    }

    function initializeDates() {
        $scope.dateToday = new Date();
        $scope.datePrevious = timeframe.isCustomRange() ? null : timeframe.getPrettyFromDate('LL');
    }

    function initializeSort() {
        $state.go('.', {'sort': 'first_name', 'order': 'asc'}, {notify: false, location: 'replace'});
    }

    function initializeData(item) {
        $scope.item = item;

        initializeDates();
        timeframeChanged();
    }

    function timeframeChanged() {
        $rootScope.reportDates = undefined;
        updateStudents();
    }

    $scope.getColorByStatus = function(columnId, row) {
        if (row[columnId + '_status'] === 2) {
          var customerIsAdmin = authentication.getCustomer().isAdmin;
          if (customerIsAdmin !== null && customerIsAdmin) {
            // https://dreambox.atlassian.net/browse/IN-4563 --> do not return red in views for admins
            return '';
          } else {
            return 'text-warn';
          }
        } else if (row[columnId + '_status'] === 1) {
            return 'text-congratulate';
        }
    };

    $scope.handleRowClick = function(item) {
        analyticsService.eventTrack('Student Row Clicked', {
            category: 'Classroom Overview',
            label: item.id
        });
        $scope.$emit('route', item);
    };

    var authCustomer = authentication.getCustomer();


    $scope.hideTimeframeDropdown = function() {
      return !$scope.reportDates;
    };

    // Already cached student navigation data contains the student alerts (status_reason_codes) for use in print all.
    // Getting this data from here saves an extra call per student to the student highlights endpoint.
    var studentNavigationPromise = $studentApi.getStudentsForClassroom($state.params.classroomId).$promise.then(function (studentNavigationData) {
        return _.indexBy(studentNavigationData, 'id');
    });

    function getBreadcrumbNames() {
        var breadcrumbNames = [];
        if ($scope.infoHeader) {
            breadcrumbNames.push($scope.infoHeader);
        }

        _.each($scope.breadcrumbs, function (breadcrumb) {
            if (breadcrumb && breadcrumb.item) {
                breadcrumbNames.push(breadcrumb.item.name);
            }
        });

        return breadcrumbNames;
    }

    function openPrintAllStudentsModal(studentsNavigationById) {
        var breadcrumbNames = getBreadcrumbNames();

        var modalOptions = {
            templateUrl: 'resources/right-pane/components/print-all-students-modal/dbl-print-all-students-modal.html',
            windowClass: 'common-modal dbl-print-all-students-modal',
            controller: 'DblPrintAllStudentsModalController',
            backdrop: 'static',
            keyboard: false,
            resolve: {
                astName: function () {
                    return customer.getAcademicStandard().academic_standard_name;
                },
                breadcrumbNames: function () {
                    return breadcrumbNames;
                },
                students: function () {
                    var students = _.map($scope.listTableData.students_overview, function (studentOverview) {
                        var student = _.clone(studentOverview);
                        student.districtId = $state.params.districtId;

                        var studentNavigation = studentsNavigationById[student.id];
                        if (studentNavigation) {
                            student.status_reason_codes = studentNavigation.status_reason_codes;
                        }

                        return student;
                    });

                    students = _.sortBy(students, 'name');

                    return students;
                },
                studentOverviewOptions: function () {
                    return {
                        canAssignLessons: authentication.canAssignLessons(authCustomer),
                        efpEnabled: authCustomer.hasTag('INSIGHT_EFP'),
                        hideStudentPlacement: !configuration.isFeatureEnabled('student_proficiency_grid_placement_enabled'),
                        loadStandards: false,
                        viewMode: authentication.growthAsFraction()  ? 'fractionMode' : 'percentMode'
                    };
                }
            }
        };

        $modal.open(modalOptions);
    }

    $scope.printAllStudentReports = function () {
        studentNavigationPromise.then(function (studentsNavigationById) {
            openPrintAllStudentsModal(studentsNavigationById);
        });
    };

    var timeframeSubscription = timeframe.getYearListSubject().subscribe(function (years) {
        $scope.years.list = angular.copy(years);
    });

    $scope.$on('listTableRowClicked', function(e, item) {
        $scope.$emit('route', item);
    });
    $scope.$on('updateSortableTable', updateSort);
    var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(initializeData);
    $scope.$on('timeframeSelected', timeframeChanged);
    $scope.$on('timeframeInitialized', timeframeChanged);
    $scope.$on('$destroy', function () {
        itemSubscription.dispose();
        timeframeSubscription.dispose();
    });
    }]);
/* jshint +W072 */
